import { OnInit, Input, OnDestroy, Directive } from '@angular/core';
import { PaginationParams } from './../../../../models/shared/paginationParams.model';
import { Subscription } from 'rxjs';
import { CommunicationService } from './../../../../shared/services/communication.service';

import { ApiService } from './../../../../shared/services/api.service';
import { DataUtils } from './../../../../shared/utils/data-utils';

@Directive()
export class ListBase<T> implements OnInit, OnDestroy {
  private _subscription: Subscription;
  public url: string;
  public routePrefix: string;
  public q = '';
  public isInitialized = false;

  @Input()
  public set query(query: string) {
    this.q = query;
    this._getPaginationParams(query);
    this.p = 1;
    this._getItems();
  }

  public items: T[];

  public pagination: PaginationParams = {
    pageSize: 0,
    total: 0
  };

  public p = 1;

  constructor(
    private _apiService: ApiService,
    private _communicationService: CommunicationService
  ) { }

  public getTitle(titleObject: any): string {
    return DataUtils.getTitle(titleObject);
  }

  ngOnInit() {
    this._subscription = this._communicationService.modalExecuted$.subscribe(
      () => {
        this._getPaginationParams('');
        this._getItems();
      }
    );

    this._getPaginationParams('');
    this._getItems();
  }

  public pageChanged(p): void {
    this.p = p;
    this._getItems();
  }

  protected _getItems() {
    this._apiService
      .get(
        this.url +
        '/' +
        (this.q && this.q.length > 0 ? 'filter/' : '') +
        (this.q ? this.q : '') +
        '?page=' +
        this.p
      )
      .subscribe(
        (response: any) => {
          this.items = { ...response }.data;
          this.isInitialized = true;
        },
        error => console.error(error)
      );
  }

  protected _getPaginationParams(query: string) {
    if (!query) {
      query = '';
    }
    this._apiService.get(this.url + '/pagination/' + query).subscribe(
      (response: any) => {
        this.pagination = { ...response?.data };
      },
      error => console.error(error)
    );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
